// extracted by mini-css-extract-plugin
module.exports = {"td":"CustomCell_td__39N6u","greenBackground":"CustomCell_greenBackground__2yZEe"};